// Site configuration - single source of truth
export const siteConfig = {
  brandName: "Nayra",
  tagline: "Stylish & Versatile Look",
  phone: "+91 96808 64075",
  phoneRaw: "+919680864075",
  whatsappNumber: "919680864075",
  whatsappMessage: "Hi, I have a query.",
  aboutTitle: "About Us",
  aboutText:
    "We believe luxury footwear is more than fashion\u2014it is a statement of confidence. Our collection is carefully curated for customers who appreciate premium materials, refined design, and exceptional comfort.",
  ctaTitle: "Get In Touch With Nayra",
  ctaSubtitle: "If You Have Any Quiery, Click The Link Below.",
  heroImage:
    "https://images.pexels.com/photos/17628651/pexels-photo-17628651.jpeg",
  ctaImage:
    "https://images.pexels.com/photos/9420724/pexels-photo-9420724.jpeg",
};

export const whatsappLink = (cfg = siteConfig) =>
  `https://wa.me/${cfg.whatsappNumber}?text=${encodeURIComponent(cfg.whatsappMessage)}`;
